const ISO_WEEKDAYS = new Set([1, 2, 3, 4, 5]);

/** ISO weekdays (1=Mon … 5=Fri) the student may leave school without pickup. */
export function getLeavesAloneWeekdays(
    leavesAlone: number[] | null | undefined,
): number[] {
    if (!leavesAlone) {
        return [];
    }

    return [
        ...new Set(leavesAlone.filter((day) => ISO_WEEKDAYS.has(day))),
    ].sort((left, right) => left - right);
}

/**
 * Localized weekdays the student may leave school without pickup.
 * Returns undefined when no weekday is allowed.
 */
export function getLeavesAloneSummary(
    leavesAlone: number[] | null | undefined,
    weekdayLabel: (isoWeekday: number) => string,
): string | undefined {
    const days = getLeavesAloneWeekdays(leavesAlone);

    if (days.length === 0) {
        return undefined;
    }

    return days.map(weekdayLabel).join(", ");
}
